export default __webpack_public_path__ + "images/44_2_image.jpg";